<app-dashboard-widget-card [titleKey]="titleKey">
  @if (items.length === 0) {
  <div class="empty-row">{{ emptyKey | translate }}</div>
  } @else {
  <ul class="latest-list">
    @for (item of items; track item.primary + item.createdAt) {
    <li class="latest-item">
      <div class="item-primary">{{ item.primary }}</div>
      <div class="item-secondary">{{ item.secondary }}</div>
      <div class="item-date">{{ item.createdAt }}</div>
    </li>
    }
  </ul>
  }
</app-dashboard-widget-card>
